import Header from "../home/header.js"
import Serviceheader from "./serviceheader"
import About from "../home/about.js"
import OwnerPointofview from "./ownerPointofview.js"
import Services from "../home/services.js"
import Testimonials from "../home/testimonial.js"
import Contactnow from "../home/contactnow.js"
import Footer from "../home/footer.js"
import Portfolio from '../home/portfolio.js'
import Dreamcontact from "../home/dreamcontact.js"
const servicepage=()=>{
    return(
        <>
            <Header/>
            <Serviceheader/>
            <OwnerPointofview/>
            <Services/> 
            <About/>   
            <Portfolio/>
            <Testimonials/> 
            <Dreamcontact/>    
            <Footer/>
        </>
    )
}
export default servicepage